import {IDeviceTypesDict} from './deviceTypesDict.types';
import {IDocument} from './document.types';
import {IJSONResponse} from './json-response.types';
import {IServiceRequestMetadata, TypeServiceRequestStatusCode} from './serviceRequest.types';
import {TypeAccountRoles} from './user-account.types';

export enum WorkContentType {
  DOCUMENTS = 'DOCUMENTS',
  SOURCE_CONTENT = 'SOURCE_CONTENT',
  WORK_DATA = 'WORK_DATA',
}

export enum InputTypeEnum {
  STRING = 'STRING',
  NUMBER = 'NUMBER',
  DATE = 'DATE',
  BARCODE = 'BARCODE',
  IMAGE = 'IMAGE',
  FILE_PICKER = 'FILE_PICKER',
  VIDEO = 'VIDEO',
  AUDIO = 'AUDIO',
  MULTIPLE = 'MULTIPLE',
}

export interface IWorkStage {
  id: number;
  name: string;
  sortOrder: number;
}

export interface IWorkContentItem {
  id: number;
  serviceRequestId: number;
  workContent: IWorkContent;
  workContentId: number;
}

export interface IWorkContentTextItem extends IWorkContentItem {
  text: string;
}

export interface IWorkContentDocumentsItem extends IWorkContentItem {
  documents: IDocument[];
}

export type IWorkContentFull = {
  id: number;
  name: string;
  stage: IWorkStage;
  stageId: number;
  deviceTypeCode: string;
  sortOrder: number;
  field: IServiceRequestMetadata;
  fieldId: number;
  modelName: string;
  itemId?: number;
  deletedDate?: string;
  inputType?: InputTypeEnum;
  defaultValue?: string;
  mandatory?: boolean;
  maxFilesAllowed?: number;
  availableFileExtensions?: string;
} & (
  | {
      item?: IWorkContentDocumentsItem;
      type: WorkContentType.DOCUMENTS;
    }
  | {
      item?: IWorkContentTextItem;
      type: WorkContentType.WORK_DATA | WorkContentType.SOURCE_CONTENT;
    }
);

export interface IWorkContent {
  id: number;
  name: string;
  type: WorkContentType;
  stage: IWorkStage;
  deviceType: IDeviceTypesDict;
  deviceTypeCode: string;
  sortOrder: number;
  fieldName: string;
  field: IServiceRequestMetadata;
  fieldId: number;
  deletedDate?: string;
}

export interface IContentTreeItem {
  id: number;
  name: string;
  workContents: IWorkContentFull[];
  sortOrder: number;
  availableForEdit: TypeAccountRoles[];
  availableForRoles: TypeAccountRoles[];
  availableForStatuses: TypeServiceRequestStatusCode[];
}

export interface IJSONResponseListWorkContentDto extends IJSONResponse {
  data: IWorkContent[];
}

export interface IJSONResponseListWorkStageDto extends IJSONResponse {
  data: IWorkStage[];
}

export interface IWorkContentSpec extends Partial<IWorkContent> {}
